import React, { Component } from 'react';
import { connect } from 'react-redux';
import LOOKUP from '../../../constants/lookup';
import GenericTable from '../../components/advanced/GenericTable';
import { getUserRolePageByName } from '../../../actions/EntityActions';
import Grid from '../../components/basic/Grid';
import { Link } from 'react-router-dom';
import { getUserBranches, getStores, selectStore, showError } from '../../../actions/CommonActions';
import WithRouter from 'custom/withRouter';

class StoreList extends Component {
    
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        localStorage.setItem('IsLoggedOut', "false");
        this.props.getStores();
    }

    componentDidUpdate(prevProps) {
        const changeStoreClickedAgain = !this.props.stores && this.props.stores != prevProps.stores;
        const hasSingleStore = this.props.stores && this.props.stores != prevProps.stores && this.props.stores.length < 2;

        if (changeStoreClickedAgain) {
            this.props.getStores();
        }

        if (hasSingleStore) {
            this.initStoreSelected(this.props.stores[0]);
        }
    }

    initStoreSelected = (item = null) => {
        const stores = this.props.stores;
        if (!stores || stores.length < 1) {
            this.props.showError("No stores are available.")
            return
        }
        const companyCode = item ? item.companyCode : stores[0].companyCode;
        const cleanCompanyCode = companyCode.replace(/^"(.*)"$/, '$1');
        const apiUrls = item ? item.apiUrls : null;
        
        localStorage.setItem('TECHPOS_CompanyCode', cleanCompanyCode);
        localStorage.setItem('TECHPOS_ApiUrl', JSON.stringify(apiUrls));

        let folderName = apiUrls != null ? apiUrls.frontendBaseFolderName : ""
        localStorage.setItem('TECHPOS_FolderName', JSON.stringify(folderName));


        // this.props.selectStore();
        // this.props.getUserBranches(this.props.userName);

        // const userRole = this.props.authenticatedUser.roles;
        // this.props.getUserRolePageByName(userRole[0]);

        this.props.navigate("/")
        window.location.href = `/${folderName}`
    }

    handleFilterChange = (value) => {
        const model = {
            branchId: this.props.branchId,
            status: value
        };
        this.props.getStore(model);
    };

    render() {   
        const listStores = (this.props.stores || []).map((item) => {
            const handleNameClick = () => {
                this.initStoreSelected(item);
            };

            const newId = `${item.name.replace(/ /g,"_")}`
            
            return {
                Name: <Link to="#" id={newId} onClick={handleNameClick}>{item.name}</Link>,
                WebSite: item.webSite,
                CompanyCode: item.companyCode
            };
        });

        return (
            <Grid>
                <div className="row m-0 pt-2 pb-3">
                    <div className="col-lg-6">
                        <h2>{LOOKUP.menu.store.text}</h2>
                    </div>
                </div> 
                <div className="list-table">
                    <div className="form-group">
                        <GenericTable 
                            className="table_center tableHeaderwhiteColorFont"
                            multiSelectable={false}
                            enableSelectAll={false}
                            displaySelectAll={false}
                            adjustForCheckbox={false}
                            displayRowCheckbox={false}
                            selectable={false}
                            stripedRows={true}
                            columns={LOOKUP.store.tableColumns}
                            rows={listStores} />
                    </div>
                </div>
            </Grid>
        );
    }
}

function mapStatetoProps(state) {
    return {
        stores: state.common.storesList,
        userName: state.common.authenticatedUser ? state.common.authenticatedUser.userName : '',
        authenticatedUser: state.common.authenticatedUser,
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        getStores: () => dispatch(getStores()),
        getUserBranches: (userName) => dispatch(getUserBranches(userName)),
        getUserRolePageByName: (roleName) => dispatch(getUserRolePageByName(roleName)),
        selectStore: () => dispatch(selectStore()),
        showError: (message) => dispatch(showError(message)),
    };
}

export default connect(mapStatetoProps, mapDispatchToProps)(WithRouter(StoreList));
